import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
   { path: '', redirectTo: '/hire', pathMatch: 'full' },
  {
    path: 'changelog',
    loadChildren: ()=> import('./hire/hire.module').then(m => m.HireModule)
  },
  {
    path: 'hire',
    loadChildren: ()=> import('./hire/hire.module').then(m => m.HireModule)
  },
  {
    path: 'client',
    loadChildren: ()=> import('./client/client.module').then(m => m.ClientModule)
  },
  {
    path: 'server',
    loadChildren: ()=> import('./server/server.module').then(m => m.ServerModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
